import * as React from "react"
import { Appearance, TextInput, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { Input, InputProps } from "../input/input"
import { Icon } from "native-base"
import { JalaIcon } from "../jala-icon/jala-icon"
import { useCallback, useEffect, useRef, useState } from "react"

export interface DateTimePickerProps extends InputProps {
  onValueChange: (value) => void,
  onOpen?: () => void,
  onClose?: () => void,

  colorScheme?: "dark" | "light",
  clearable?: boolean,

  format?: string,
  displayFormat?: string,

  dateTimePickerProps?: any
}

const INPUT: ViewStyle = {
  flexGrow: 1,
  height: "42px",
  paddingVertical: 6
}

/**
 * Describe your component here
 */
export const DateTimePicker = observer(function DateTimePicker(props: DateTimePickerProps) {
  const {
    onValueChange, onOpen: onOpenProp, onClose: onCloseProp,
    isDisabled, colorScheme = Appearance.getColorScheme(),
    defaultValue, value,
    InputRightElement,
    dateTimePickerProps = {} as any,
    format = dateTimePickerProps.mode === "time" ? "HH:mm:ss" : "YYYY-MM-DD",
    displayFormat = dateTimePickerProps.mode === "time" ? "HH:mm" : "DD MMMM YYYY",
    ...rest
  } = props

  const [ internalValue, setInternalValue ] = useState<string|null|undefined>(value || defaultValue)

  const inputRef = useRef<TextInput>()

  useEffect(() => {
    if (inputRef?.current) {
      inputRef?.current?.setNativeProps({
        type: dateTimePickerProps.mode || 'date',
      })
    }
  }, [dateTimePickerProps.mode])

  useEffect(() => {
    setInternalValue(value)
  }, [value])

  const onChange = useCallback<(event, date?: Date) => void>((event, date) => {
    if (event.type === "neutralButtonPressed") {
      setInternalValue('')
      onValueChange(null)
    }
    else if (event.type === "change" ) {
      const value = event.nativeEvent.text
      setInternalValue(value)
      onValueChange(value)
    }
  }, [onValueChange])

  return (
    <Input
      ref={inputRef}
      colorScheme={colorScheme}
      type={dateTimePickerProps.mode || 'date'}
      isDisabled={isDisabled}
      value={internalValue}
      onChange={onChange}
      style={INPUT}
      {...rest}
      InputRightElement={InputRightElement ||
        <Icon as={<JalaIcon name="danger" />}
              testID={`${(rest.testID || "")}-clear`} size={"16px"} mr={"9px"} textAlign="center"
              backgroundColor={rest.backgroundColor} color="#666666"
              onPress={!isDisabled && (() => onChange({ type: 'neutralButtonPressed' })) || undefined} />}
    />
  )
})
